import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import GlobalSearch from '../components/GlobalSearch';
import KeyboardShortcutsModal from '../components/KeyboardShortcutsModal';
import './AppLayout.css';

const AppLayout = () => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isShortcutsOpen, setIsShortcutsOpen] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      console.log('🔑 Key pressed:', e.key, 'Ctrl:', e.ctrlKey, 'Meta:', e.metaKey);

      // Ctrl+K / Cmd+K para busca global
      if ((e.ctrlKey || e.metaKey) && (e.key === 'k' || e.key === 'K')) {
        console.log('🔍 Abrindo busca');
        e.preventDefault();
        setIsSearchOpen(true);
        return;
      }

      // ? para atalhos (fora de inputs)
      if (e.key === '?' && !['INPUT', 'TEXTAREA'].includes(e.target.tagName)) {
        console.log('❓ Abrindo atalhos');
        e.preventDefault();
        setIsShortcutsOpen(true);
        return;
      }

      // Esc para fechar modais
      if (e.key === 'Escape') {
        console.log('✕ Fechando modais');
        setIsSearchOpen(false);
        setIsShortcutsOpen(false);
      }
    };

    // Use capture phase to catch events earlier
    window.addEventListener('keydown', handleKeyDown, true);
    return () => window.removeEventListener('keydown', handleKeyDown, true);
  }, []);

  return (
    <div className="app-layout">
      {/* Mobile hamburger button */}
      <button
        className={`mobile-menu-toggle ${isMobileSidebarOpen ? 'open' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsMobileSidebarOpen(!isMobileSidebarOpen);
        }}
        onContextMenu={(e) => e.preventDefault()}
        onTouchStart={(e) => {
          e.preventDefault();
        }}
        aria-label="Menu"
        title={isMobileSidebarOpen ? 'Fechar menu' : 'Abrir menu'}
        style={{ display: 'none' }}
      >
        <span className="hamburger-lines">
          <span className="line line-1"></span>
          <span className="line line-2"></span>
          <span className="line line-3"></span>
        </span>
      </button>

      {/* Sidebar com classe mobile-open quando aberto */}
      <div className={`sidebar ${isMobileSidebarOpen ? 'mobile-open' : ''}`}>
        <Sidebar onShortcutsClick={() => setIsShortcutsOpen(true)} />
      </div>

      {/* Fechar sidebar ao clicar no overlay */}
      {isMobileSidebarOpen && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 998,
            display: 'none'
          }}
          onClick={() => setIsMobileSidebarOpen(false)}
        />
      )}

      <main className="app-content">
        <Outlet />
      </main>

      <GlobalSearch isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} />
      <KeyboardShortcutsModal isOpen={isShortcutsOpen} onClose={() => setIsShortcutsOpen(false)} />

      {/* CSS para mostrar hamburger em mobile */}
      <style>{`
        @media (max-width: 600px) {
          .mobile-menu-toggle {
            display: flex !important;
          }
        }
      `}</style>
    </div>
  );
};

export default AppLayout;